import { ATTRS, TAGS } from '../constants';
import { Entity } from '../types';

export class ValuePresentationEntity implements Entity {
  public static fromXML(xml, matchIDs) {
    const attrs = xml._attributes;
    const isoId = attrs[ATTRS.ValuePresentation.ValuePresentationId];
    return {
      entity: new ValuePresentationEntity(
        matchIDs[isoId] ? matchIDs[isoId].id : null,
        parseFloat(attrs[ATTRS.ValuePresentation.Offset]),
        parseFloat(attrs[ATTRS.ValuePresentation.Scale]),
        parseInt(attrs[ATTRS.ValuePresentation.NumberOfDecimals], 10),
        attrs[ATTRS.ValuePresentation.UnitDesignator]
      ),
      isoId,
    };
  }
  public type = TAGS.ValuePresentation;

  constructor(
    public id: string,
    public offset: number,
    public scale: number,
    public numberOfDecimals: number,
    public title: string
  ) {}

  public toXML(xmlId: string) {
    return {
      _attributes: {
        [ATTRS.ValuePresentation.ValuePresentationId]: xmlId,
        [ATTRS.ValuePresentation.Offset]: this.offset,
        [ATTRS.ValuePresentation.Scale]: this.scale,
        [ATTRS.ValuePresentation.NumberOfDecimals]: this.numberOfDecimals,
        [ATTRS.ValuePresentation.UnitDesignator]: this.title,
      },
    };
  }

  public getValuePresentation(value: number): string {
    return ((value + this.offset) * this.scale).toFixed(this.numberOfDecimals);
  }
}
